import { ChangeDetectorRef, Component, forwardRef, AfterViewChecked, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { VrDatepicker } from './models/vr-datepicker';

const VRC_DATEPICKER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => VrcDatepickerComponent),
  multi: true
};

@Component({
  selector: 'vrc-datepicker',
  templateUrl: './vrc-datepicker.component.html',
  styleUrls: ['./vrc-datepicker.component.scss'],
  providers: [VRC_DATEPICKER_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VrcDatepickerComponent extends VrDatepicker implements AfterViewChecked {

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }
}
